<template>
  <div id="app" class="app">
    <auth-layout v-if="isAuth"></auth-layout>
    <layout v-else></layout>
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.13/css/all.css" crossorigin="anonymous"/>
  </div>
</template>

<script>
  import Layout from 'components/layout/Layout';
  import AuthLayout from 'components/layout/AuthLayout';
  import VuesticPreLoader from 'vuestic-components/vuestic-preloader/VuesticPreLoader.vue';

  export default {
    name: 'app',
    components: {
      VuesticPreLoader,
      AuthLayout,
      Layout,
    },
    computed: {
      isAuth () {
        return this.$route.path.match('auth');
      },
    },
  };
</script>

<style lang="scss">
  @import "sass/main";

  body {
    height : 100%;
    #app {
      height : 100%;
    }
  }

  .widget-header {
    .disabled {
      opacity : .5;
      color   : $gray;
    }
    .header-text {
      display      : flex;
      font-size    : 1rem;
      font-weight  : normal;
      margin-right : $form-check-input-gutter;

      > * {
        margin-top    : 0;
        margin-bottom : 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue